import { Injectable } from '@angular/core';
import { Resolve, ActivatedRouteSnapshot, RouterStateSnapshot } from '@angular/router';
import { Observable } from 'rxjs/Rx';
import { CommunicationsHttpService } from '../services/communications/communications.http.service';
import { DashboardHttpUtil } from '../components/dashboard/dashboard.util';
import { CommunicationsHttpUtil } from '../components/dashboard/communications/communications.util';
import { StorageUtil } from '../utils/storage.util';

@Injectable()
export class CommunicationsResolver implements Resolve<any> {

  model: any = {
    data: ''
  };

  constructor(private communicationsHttpService: CommunicationsHttpService) {
  }

  resolve(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): Observable<any> {
    // let requestParams = DashboardHttpUtil.prepareTokenParam(StorageUtil.getToken());
    // return this.communicationsHttpService.getQuest(requestParams);
    let requestParams = CommunicationsHttpUtil.prepareParamsGetChats({
      securityToken: StorageUtil.getToken(),
      active: 1,
    });
    return this.communicationsHttpService.getChats(requestParams);
  }
}



// WEBPACK FOOTER //
// ./src/app/resolves/communications.resolver.ts